<div class="jit-migration-popup registration-popup">
  <ng-container *ngIf="step === 1">
    <div *ngIf="otpRateLimitBanner" class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="alert alert-danger ciam-v6-rate-banner" role="alert">
          <span>{{ otpRateLimitBanner }}</span>
          <a *ngIf="otpShowContactUs" href="/contact-us" class="ciam-v6-inline-help">Contact us</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2 class="text-center" id="JitMigrationModalLabel">Update Sign In</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <span class="hint-text text-center mg-btm-32">Please verify your email address:</span>
      </div>
    </div>
    <form [formGroup]="identifierForm" (ngSubmit)="onContinue()" novalidate>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
          <div class="form-group" [ngClass]="{ 'ng-invalid': identifierForm.get('identifier')?.invalid && identifierForm.get('identifier')?.touched }">
            <label for="identifier">Email</label>
            <input type="email" class="form-control" id="identifier" name="identifier"
              placeholder="Enter your email"
              formControlName="identifier" />
            <app-validation-message [control]="identifierForm.controls.identifier"
              [updateOn]="updateTrigger.Dirty"></app-validation-message>
            <div class="form-error valid-error" *ngIf="identifierForm.get('identifier')?.hasError('email') && identifierForm.get('identifier')?.dirty">
              Please enter a valid email address.
            </div>
          </div>
        </div>
      </div>
      <div class="form-error valid-error" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="row mg-top-24">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <button type="submit" class="btn wb-btn-default center-block" [disabled]="loading || identifierForm.invalid || otpContinueDisabled">
            {{ loading ? 'Sending...' : 'SEND CODE' }}
          </button>
        </div>
      </div>
      <div class="text-center mg-top-24 mg-btm-9" *ngIf="!isMandatory">
        <span role="button" (click)="onDismiss()" class="forget-sign-link">Cancel</span>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="step === 2">
    <div *ngIf="otpRateLimitBanner" class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="alert alert-danger ciam-v6-rate-banner" role="alert">
          <span>{{ otpRateLimitBanner }}</span>
          <a *ngIf="otpShowContactUs" href="/contact-us" class="ciam-v6-inline-help">Contact us</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2 class="text-center" id="JitMigrationOtpLabel">Verify Your Email</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <span class="hint-text text-center mg-btm-32">Enter the code we sent to {{ identifierValue }}.</span>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <span class="hint-text text-center">
          Didn&apos;t get the code?
          <span *ngIf="resendCooldownSeconds > 0" class="resend-link disabled">Resend code in {{ resendCooldownSeconds }}s</span>
          <span *ngIf="resendCooldownSeconds <= 0" (click)="onResend()" role="button" class="resend-link" [class.disabled]="loading || otpResendDisabled">Resend code</span>
        </span>
      </div>
    </div>
    <form [formGroup]="otpForm" (ngSubmit)="onVerify()" novalidate>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
          <div class="form-group" [ngClass]="{ 'ng-invalid': otpForm.get('otpCode')?.invalid && otpForm.get('otpCode')?.touched }">
            <label for="otpCode">Code</label>
            <input type="text" class="form-control" id="otpCode" name="otpCode" autocomplete="one-time-code"
              formControlName="otpCode" mask="000000" [showMaskTyped]="false"
              placeholder="Enter 6-digit code" maxlength="6" />
            <app-validation-message [control]="otpForm.controls.otpCode"
              [updateOn]="updateTrigger.Dirty" ignoreDirtyValidationPattern="^\d{1,6}$"></app-validation-message>
          </div>
        </div>
      </div>
      <div class="form-error valid-error" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="row mg-top-24">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <button type="submit" class="btn wb-btn-default center-block"
            [disabled]="loading || otpForm.invalid || otpContinueDisabled">
            {{ loading ? 'Verifying...' : 'CONTINUE' }}
          </button>
        </div>
      </div>
      <div class="text-center mg-top-24 mg-btm-9">
        <span role="button" (click)="onBack()" class="forget-sign-link mg-right-8">Back</span>
        <span role="button" (click)="onDismiss()" class="forget-sign-link" *ngIf="!isMandatory">Cancel</span>
      </div>
    </form>
  </ng-container>
</div>
